import { BaseReducer } from '@hobs/utils/baseReducer';
import { FORSUBMIT, GET, CLEAR } from '@hobs/constants/users';

class Users extends BaseReducer {
  static defaultState = {
    userForSubmit: {},
    user: null
  };

  constructor() {
    super(Users.defaultState);

    this.actionMap = {
      [FORSUBMIT.SUCCESS]: this.getUserForSubmit,
      [GET.SUCCESS]: this.getUser,
      [CLEAR.SUCCESS]: this.clearUser
    };
  }

  getUserForSubmit = (state, action) => {
    return Object.assign({}, state, {
      userForSubmit: action.response
    });
  };

  getUser = (state, action) => {
    return Object.assign({}, state, {
      user: action.response
    });
  };

  clearUser = state => {
    return Object.assign({}, state, { userForSubmit: {}, user: null });
  };
}
export default new Users().reducer;
